module.exports = __webpack_public_path__ + "media/images/front/seminars/surgeon_cram_school_no4-ad530cd37227b5976ed8b995824754c8.jpg";